import { create } from "zustand";

export interface UiModulesStore {
  flexPassUiModule: boolean;
  setFlexPassUiModule: (value: boolean) => void;
}

export const useUiModulesStore = create<UiModulesStore>((set) => ({
  flexPassUiModule: false,
  setFlexPassUiModule: (value: boolean) => set({ flexPassUiModule: value }),
}));
